import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import './styles.scss'

@observer
class SavedLegalAddressDetail extends React.Component {
  @observable phoneNumber = ''
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const { phone = '' } = this.props?.address || {}
    this.phoneNumber = await this.getPhoneNumber(phone)
  }

  getPhoneNumber = async (phone = '') => {
    let phoneNumberCode = ''
    try {
      if (phone && phone != null) {
        const { parsePhoneNumber } = await import('libphonenumber-js')
        phoneNumberCode = parsePhoneNumber(phone)?.formatInternational() || ''
      }
    } catch (e) {
      console.log('Phone number Parse exception ', e)
    }
    return phoneNumberCode
  }

  render() {
    const { address = {} } = this.props
    const {
      firstName = '',
      lastName = '',
      addressLine1 = '',
      addressLine2 = '',
      city = '',
      state = '',
      county = '',
      country = '',
      zip = '',
      email = '',
      phone = '',
      isDefault = false,
    } = address

    // CX115-2828 - As per BA's confirmation, User Info details will be hidden in the UI
    let isToHideUserInfo = true
    let customClassName = isToHideUserInfo ? 'd-none' : ''

    return (
      <div
        className="legal-address-saved-address-details"
        data-testid="qa-legal-address-wrapper">
        <div
          className={`legal-address-name-details ${customClassName}`}
          data-testid="qa-legal-address-name-wrapper">{`${firstName} ${lastName}`}</div>
        <div
          className="legal-address-details"
          data-testid="qa-legal-address-line-wrapper">{`${addressLine1},${
          addressLine2 ? ` ${addressLine2},` : ''
        }`}</div>
        <div
          className="legal-address-details"
          data-testid="qa-legal-address-details-wrapper">{`${
          city ? city + ',' : ''
        }${county ? ' ' + county + ',' : ''} ${
          state ? state + ',' : ''
        } ${zip}`}</div>
        <div
          className="legal-address-details"
          data-testid="qa-legal-address-country">{`${country}`}</div>
        <div
          className={`legal-address-details legal-address-email ${customClassName}`}
          data-testid="qa-legal-address-email">{`${email}`}</div>
        {this.phoneNumber && (
          <div
            className={`legal-address-details legal-address-phone ${customClassName}`}
            data-testid="qa-legal-address-phone-wrapper">
            {this.phoneNumber}
          </div>
        )}
        {isDefault && (
          <div
            className={`legal-address-default mt-2 ${customClassName}`}
            data-testid="qa-legal-address-default-wrapper">
            Default Address
          </div>
        )}
      </div>
    )
  }
}

export default SavedLegalAddressDetail
export { SavedLegalAddressDetail }
